import React from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import { Button, ModalBody } from '@adeccoux/tag-ds';
import { Box, Modal } from '@mui/material';

import styles from './ErrorPageDialog.module.scss';

interface ErrorPageDialogProps {
  isVisible: boolean;
  setIsDataCheckerError: any;
}

const ErrorPageDialog: React.FC<ErrorPageDialogProps> = ({ isVisible, setIsDataCheckerError }) => {
  const { t } = useTranslation(['documents']);

  return (
    <Modal open={isVisible}>
      <Box className={clsx('tag-ds', styles.modal)}>
        <ModalBody style={{ marginBottom: 48 }}>
          <div className={styles.modal__mainDiv}>
            <img src="/images/alert_icon_bg.png" alt="404" />
            <p className={styles.modal__mainDiv__errorHeading}>{t('documents:DATACHECKER.idVerifyError.label')}</p>
            <p className={styles.modal__mainDiv__errorDescription}>
              {t('documents:DATACHECKER.idVerifyError.description')}
            </p>
            <Button
              style={{ marginTop: '80px' }}
              className="button-primary"
              onClick={() => {
                setIsDataCheckerError(false);
              }}
            >
              {t('documents:DATACHECKER.retry.label')}
            </Button>
          </div>
        </ModalBody>
      </Box>
    </Modal>
  );
};

export default ErrorPageDialog;
